// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, RequestResult, TDataShape } from '@hey-api/client-axios';

import { client } from './client.gen';

type ApiClientMetaValue = string | number | boolean | null | undefined | ApiClientMetaValue[] | { [key: string]: ApiClientMetaValue };
import type { GetApiAirportData, GetApiAirportErrors, GetApiAirportResponses, GetApiB2bAccountUserCurrentData, GetApiB2bAccountUserCurrentErrors, GetApiB2bAccountUserCurrentResponses, GetApiB2bAnnualUpdatesData, GetApiB2bAnnualUpdatesErrors, GetApiB2bAnnualUpdatesResponses, GetApiB2bApplicationByIdCopiedFromSnapshotsData, GetApiB2bApplicationByIdCopiedFromSnapshotsErrors, GetApiB2bApplicationByIdCopiedFromSnapshotsResponses, GetApiB2bApplicationByIdFormStateData, GetApiB2bApplicationByIdFormStateErrors, GetApiB2bApplicationByIdFormStateResponses, GetApiB2bApplicationByIdGetData, GetApiB2bApplicationByIdGetErrors, GetApiB2bApplicationByIdGetResponses, GetApiB2bApplicationByIdGetUnitDataData, GetApiB2bApplicationByIdGetUnitDataErrors, GetApiB2bApplicationByIdGetUnitDataResponses, GetApiB2bDismissNotificationByIdData, GetApiB2bDismissNotificationByIdErrors, GetApiB2bDismissNotificationByIdResponses, GetApiB2bEmissionTypesByCountryCodeData, GetApiB2bEmissionTypesByCountryCodeErrors, GetApiB2bEmissionTypesByCountryCodeResponses, GetApiB2bGetStaticFileData, GetApiB2bGetStaticFileErrors, GetApiB2bGetStaticFileResponses, GetApiB2bGetStaticsData, GetApiB2bGetStaticsErrors, GetApiB2bGetStaticsResponses, GetApiB2bInviteByInviteTokenData, GetApiB2bInviteByInviteTokenErrors, GetApiB2bInviteByInviteTokenResponses, GetApiB2bPackageByIdComparisonData, GetApiB2bPackageByIdComparisonErrors, GetApiB2bPackageByIdComparisonResponses, GetApiB2bPackagesData, GetApiB2bPackagesErrors, GetApiB2bPackagesResponses, GetApiB2bPaymentConfirmData, GetApiB2bPaymentConfirmErrors, GetApiB2bPaymentConfirmResponses, GetApiB2bReportsApplicationReportData, GetApiB2bReportsApplicationReportErrors, GetApiB2bReportsApplicationReportResponses, GetApiB2bReportsFinanceReportData, GetApiB2bReportsFinanceReportErrors, GetApiB2bReportsFinanceReportResponses, GetApiB2bReportsReductionInitiativesReportData, GetApiB2bReportsReductionInitiativesReportErrors, GetApiB2bReportsReductionInitiativesReportResponses, GetApiCountryByCountryCodeData, GetApiCountryByCountryCodeErrors, GetApiCountryByCountryCodeResponses, GetApiCountryData, GetApiCountryErrors, GetApiCountryResponses, GetApiPingData, GetApiPingErrors, GetApiPingResponses, GetOauth2CallbackB2bData, GetOauth2CallbackB2bErrors, GetOauth2CallbackB2bResponses, GetPdfBusinessInvoiceByIdData, GetPdfBusinessInvoiceByIdErrors, GetPdfBusinessInvoiceByIdResponses, GetPdfBusinessStatusDocumentByIdData, GetPdfBusinessStatusDocumentByIdErrors, GetPdfBusinessStatusDocumentByIdResponses, PostApiB2bAccountUserInfoData, PostApiB2bAccountUserInfoErrors, PostApiB2bAccountUserInfoResponses, PostApiB2bApplicationByIdCollectInitiativeDataData, PostApiB2bApplicationByIdCollectInitiativeDataErrors, PostApiB2bApplicationByIdCollectInitiativeDataResponses, PostApiB2bApplicationByIdDebugTransitionData, PostApiB2bApplicationByIdDebugTransitionErrors, PostApiB2bApplicationByIdDebugTransitionResponses, PostApiB2bApplicationByIdEditData, PostApiB2bApplicationByIdEditErrors, PostApiB2bApplicationByIdEditResponses, PostApiB2bApplicationByIdEnableAnnualUpdateData, PostApiB2bApplicationByIdEnableAnnualUpdateErrors, PostApiB2bApplicationByIdEnableAnnualUpdateResponses, PostApiB2bApplicationByIdFormAmendData, PostApiB2bApplicationByIdFormAmendErrors, PostApiB2bApplicationByIdFormAmendMetaData, PostApiB2bApplicationByIdFormAmendMetaErrors, PostApiB2bApplicationByIdFormAmendMetaResponses, PostApiB2bApplicationByIdFormAmendResponses, PostApiB2bApplicationByIdInitiativeAttachmentByAttachmentIdStatusData, PostApiB2bApplicationByIdInitiativeAttachmentByAttachmentIdStatusErrors, PostApiB2bApplicationByIdInitiativeAttachmentByAttachmentIdStatusResponses, PostApiB2bApplicationByIdInitiativeEstimateReduceData, PostApiB2bApplicationByIdInitiativeEstimateReduceErrors, PostApiB2bApplicationByIdInitiativeEstimateReduceResponses, PostApiB2bApplicationByIdMarkAnnualUpdateCompleteData, PostApiB2bApplicationByIdMarkAnnualUpdateCompleteErrors, PostApiB2bApplicationByIdMarkAnnualUpdateCompleteResponses, PostApiB2bApplicationByIdRemoveInviteByInviteIdData, PostApiB2bApplicationByIdRemoveInviteByInviteIdErrors, PostApiB2bApplicationByIdRemoveInviteByInviteIdResponses, PostApiB2bApplicationByIdResendInviteByInviteIdData, PostApiB2bApplicationByIdResendInviteByInviteIdErrors, PostApiB2bApplicationByIdResendInviteByInviteIdResponses, PostApiB2bApplicationByIdSendInviteData, PostApiB2bApplicationByIdSendInviteErrors, PostApiB2bApplicationByIdSendInviteResponses, PostApiB2bApplicationByIdSetInviteAcceptedData, PostApiB2bApplicationByIdSetInviteAcceptedErrors, PostApiB2bApplicationByIdSetInviteAcceptedResponses, PostApiB2bApplicationByIdSetInviteDeclinedData, PostApiB2bApplicationByIdSetInviteDeclinedErrors, PostApiB2bApplicationByIdSetInviteDeclinedResponses, PostApiB2bApplicationByIdSetInviteRequestedByOperationData, PostApiB2bApplicationByIdSetInviteRequestedByOperationErrors, PostApiB2bApplicationByIdSetInviteRequestedByOperationResponses, PostApiB2bApplicationByIdSetUnitDataData, PostApiB2bApplicationByIdSetUnitDataErrors, PostApiB2bApplicationByIdSetUnitDataResponses, PostApiB2bApplicationByIdTransitionData, PostApiB2bApplicationByIdTransitionErrors, PostApiB2bApplicationByIdTransitionResponses, PostApiB2bApplicationData, PostApiB2bApplicationErrors, PostApiB2bApplicationResponses, PostApiB2bCalculateSafetyFactorData, PostApiB2bCalculateSafetyFactorErrors, PostApiB2bCalculateSafetyFactorResponses, PostApiB2bPackageByIdArchiveData, PostApiB2bPackageByIdArchiveErrors, PostApiB2bPackageByIdArchiveResponses, PostApiB2bPackageByIdBaselineYearData, PostApiB2bPackageByIdBaselineYearErrors, PostApiB2bPackageByIdBaselineYearResponses, PostApiB2bPaymentExecuteByIdData, PostApiB2bPaymentExecuteByIdErrors, PostApiB2bPaymentExecuteByIdResponses, PostApiB2bPaymentWebhookData, PostApiB2bPaymentWebhookErrors, PostApiB2bPaymentWebhookResponses, PostApiB2bUserRegisterData, PostApiB2bUserRegisterErrors, PostApiB2bUserRegisterResponses, PostApiFakeLoginData, PostApiFakeLoginEmailData, PostApiFakeLoginEmailErrors, PostApiFakeLoginEmailResponses, PostApiFakeLoginErrors, PostApiFakeLoginResponses, PostApiWebSessionData, PostApiWebSessionErrors, PostApiWebSessionResponses, PostOauth2AuthorizationB2bData, PostOauth2AuthorizationB2bErrors, PostOauth2AuthorizationB2bResponses, PostOauth2LogoutB2bData, PostOauth2LogoutB2bErrors, PostOauth2LogoutB2bResponses, PostPdfBusinessCarbonEmissionsByIdData, PostPdfBusinessCarbonEmissionsByIdErrors, PostPdfBusinessCarbonEmissionsByIdResponses, PostPdfBusinessReductionDocumentByIdData, PostPdfBusinessReductionDocumentByIdErrors, PostPdfBusinessReductionDocumentByIdResponses, PostPdfBusinessReductionPlanByIdData, PostPdfBusinessReductionPlanByIdErrors, PostPdfBusinessReductionPlanByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, ApiClientMetaValue>;
};

/**
 * Get current logged in B2B user
 */
export const getApiB2bAccountUserCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bAccountUserCurrentData, ThrowOnError>): RequestResult<GetApiB2bAccountUserCurrentResponses, GetApiB2bAccountUserCurrentErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bAccountUserCurrentResponses, GetApiB2bAccountUserCurrentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/account/user/current',
    ...options
});

/**
 * Update user information
 */
export const postApiB2bAccountUserInfo = <ThrowOnError extends boolean = false>(options?: Options<PostApiB2bAccountUserInfoData, ThrowOnError>): RequestResult<PostApiB2bAccountUserInfoResponses, PostApiB2bAccountUserInfoErrors, ThrowOnError> => (options?.client ?? client).post<PostApiB2bAccountUserInfoResponses, PostApiB2bAccountUserInfoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/account/user/info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Dismiss a notification
 */
export const getApiB2bDismissNotificationById = <ThrowOnError extends boolean = false>(options: Options<GetApiB2bDismissNotificationByIdData, ThrowOnError>): RequestResult<GetApiB2bDismissNotificationByIdResponses, GetApiB2bDismissNotificationByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiB2bDismissNotificationByIdResponses, GetApiB2bDismissNotificationByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/dismiss_notification/{id}',
    ...options
});

/**
 * Register a new user
 */
export const postApiB2bUserRegister = <ThrowOnError extends boolean = false>(options?: Options<PostApiB2bUserRegisterData, ThrowOnError>): RequestResult<PostApiB2bUserRegisterResponses, PostApiB2bUserRegisterErrors, ThrowOnError> => (options?.client ?? client).post<PostApiB2bUserRegisterResponses, PostApiB2bUserRegisterErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/user/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Calculate safety factor
 */
export const postApiB2bCalculateSafetyFactor = <ThrowOnError extends boolean = false>(options?: Options<PostApiB2bCalculateSafetyFactorData, ThrowOnError>): RequestResult<PostApiB2bCalculateSafetyFactorResponses, PostApiB2bCalculateSafetyFactorErrors, ThrowOnError> => (options?.client ?? client).post<PostApiB2bCalculateSafetyFactorResponses, PostApiB2bCalculateSafetyFactorErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/calculate/safety_factor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get invite details by token
 */
export const getApiB2bInviteByInviteToken = <ThrowOnError extends boolean = false>(options: Options<GetApiB2bInviteByInviteTokenData, ThrowOnError>): RequestResult<GetApiB2bInviteByInviteTokenResponses, GetApiB2bInviteByInviteTokenErrors, ThrowOnError> => (options.client ?? client).get<GetApiB2bInviteByInviteTokenResponses, GetApiB2bInviteByInviteTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/invite/{invite_token}',
    ...options
});

/**
 * Get packages approaching their annual update date
 *
 * Returns lightweight flags for packages approaching the deadline for starting the next annual carbon review (today > reportingEndDate + 9 months). The frontend joins this with packages data from GET /api/b2b/packages.
 */
export const getApiB2bAnnualUpdates = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bAnnualUpdatesData, ThrowOnError>): RequestResult<GetApiB2bAnnualUpdatesResponses, GetApiB2bAnnualUpdatesErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bAnnualUpdatesResponses, GetApiB2bAnnualUpdatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/annual-updates',
    ...options
});

/**
 * Get available packages
 */
export const getApiB2bPackages = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bPackagesData, ThrowOnError>): RequestResult<GetApiB2bPackagesResponses, GetApiB2bPackagesErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bPackagesResponses, GetApiB2bPackagesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/packages',
    ...options
});

/**
 * Archive a package
 *
 * Sets the archived flag on a package, hiding it from the annual updates banner.
 */
export const postApiB2bPackageByIdArchive = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bPackageByIdArchiveData, ThrowOnError>): RequestResult<PostApiB2bPackageByIdArchiveResponses, PostApiB2bPackageByIdArchiveErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bPackageByIdArchiveResponses, PostApiB2bPackageByIdArchiveErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/package/{id}/archive',
    ...options
});

/**
 * Get data for year-on-year comparison
 *
 * Get reporting data for year-on-year comparisons for a given package.
 */
export const getApiB2bPackageByIdComparison = <ThrowOnError extends boolean = false>(options: Options<GetApiB2bPackageByIdComparisonData, ThrowOnError>): RequestResult<GetApiB2bPackageByIdComparisonResponses, GetApiB2bPackageByIdComparisonErrors, ThrowOnError> => (options.client ?? client).get<GetApiB2bPackageByIdComparisonResponses, GetApiB2bPackageByIdComparisonErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/package/{id}/comparison',
    ...options
});

/**
 * Set the baseline year for a package
 *
 * Sets which application should be used as the baseline year for year-on-year comparisons. Pass null to clear the baseline.
 */
export const postApiB2bPackageByIdBaselineYear = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bPackageByIdBaselineYearData, ThrowOnError>): RequestResult<PostApiB2bPackageByIdBaselineYearResponses, PostApiB2bPackageByIdBaselineYearErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bPackageByIdBaselineYearResponses, PostApiB2bPackageByIdBaselineYearErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/package/{id}/baseline-year',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a new application
 */
export const postApiB2bApplication = <ThrowOnError extends boolean = false>(options?: Options<PostApiB2bApplicationData, ThrowOnError>): RequestResult<PostApiB2bApplicationResponses, PostApiB2bApplicationErrors, ThrowOnError> => (options?.client ?? client).post<PostApiB2bApplicationResponses, PostApiB2bApplicationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get emission types
 */
export const getApiB2bEmissionTypesByCountryCode = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bEmissionTypesByCountryCodeData, ThrowOnError>): RequestResult<GetApiB2bEmissionTypesByCountryCodeResponses, GetApiB2bEmissionTypesByCountryCodeErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bEmissionTypesByCountryCodeResponses, GetApiB2bEmissionTypesByCountryCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/emission_types/{countryCode}',
    ...options
});

/**
 * Get static configuration/resources
 */
export const getApiB2bGetStatics = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bGetStaticsData, ThrowOnError>): RequestResult<GetApiB2bGetStaticsResponses, GetApiB2bGetStaticsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bGetStaticsResponses, GetApiB2bGetStaticsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/get_statics',
    ...options
});

/**
 * Get a static file
 */
export const getApiB2bGetStaticFile = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bGetStaticFileData, ThrowOnError>): RequestResult<GetApiB2bGetStaticFileResponses, GetApiB2bGetStaticFileErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bGetStaticFileResponses, GetApiB2bGetStaticFileErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/api/b2b/get_static_file',
    ...options
});

/**
 * Amend application form
 */
export const postApiB2bApplicationByIdFormAmend = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdFormAmendData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdFormAmendResponses, PostApiB2bApplicationByIdFormAmendErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdFormAmendResponses, PostApiB2bApplicationByIdFormAmendErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/form_amend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Amend application metadata
 */
export const postApiB2bApplicationByIdFormAmendMeta = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdFormAmendMetaData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdFormAmendMetaResponses, PostApiB2bApplicationByIdFormAmendMetaErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdFormAmendMetaResponses, PostApiB2bApplicationByIdFormAmendMetaErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/form_amend_meta',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get form state
 */
export const getApiB2bApplicationByIdFormState = <ThrowOnError extends boolean = false>(options: Options<GetApiB2bApplicationByIdFormStateData, ThrowOnError>): RequestResult<GetApiB2bApplicationByIdFormStateResponses, GetApiB2bApplicationByIdFormStateErrors, ThrowOnError> => (options.client ?? client).get<GetApiB2bApplicationByIdFormStateResponses, GetApiB2bApplicationByIdFormStateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/form_state',
    ...options
});

/**
 * Get unit data
 */
export const getApiB2bApplicationByIdGetUnitData = <ThrowOnError extends boolean = false>(options: Options<GetApiB2bApplicationByIdGetUnitDataData, ThrowOnError>): RequestResult<GetApiB2bApplicationByIdGetUnitDataResponses, GetApiB2bApplicationByIdGetUnitDataErrors, ThrowOnError> => (options.client ?? client).get<GetApiB2bApplicationByIdGetUnitDataResponses, GetApiB2bApplicationByIdGetUnitDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/get_unit_data',
    ...options
});

/**
 * Set unit data
 */
export const postApiB2bApplicationByIdSetUnitData = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdSetUnitDataData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdSetUnitDataResponses, PostApiB2bApplicationByIdSetUnitDataErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdSetUnitDataResponses, PostApiB2bApplicationByIdSetUnitDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/set_unit_data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept invite
 */
export const postApiB2bApplicationByIdSetInviteAccepted = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdSetInviteAcceptedData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdSetInviteAcceptedResponses, PostApiB2bApplicationByIdSetInviteAcceptedErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdSetInviteAcceptedResponses, PostApiB2bApplicationByIdSetInviteAcceptedErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/set_invite/accepted',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decline invite
 */
export const postApiB2bApplicationByIdSetInviteDeclined = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdSetInviteDeclinedData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdSetInviteDeclinedResponses, PostApiB2bApplicationByIdSetInviteDeclinedErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdSetInviteDeclinedResponses, PostApiB2bApplicationByIdSetInviteDeclinedErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/set_invite/declined',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set invite requested status
 */
export const postApiB2bApplicationByIdSetInviteRequestedByOperation = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdSetInviteRequestedByOperationData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdSetInviteRequestedByOperationResponses, PostApiB2bApplicationByIdSetInviteRequestedByOperationErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdSetInviteRequestedByOperationResponses, PostApiB2bApplicationByIdSetInviteRequestedByOperationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/set_invite_requested/{operation}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send an invite
 */
export const postApiB2bApplicationByIdSendInvite = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdSendInviteData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdSendInviteResponses, PostApiB2bApplicationByIdSendInviteErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdSendInviteResponses, PostApiB2bApplicationByIdSendInviteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/send_invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove an invite
 */
export const postApiB2bApplicationByIdRemoveInviteByInviteId = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdRemoveInviteByInviteIdData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdRemoveInviteByInviteIdResponses, PostApiB2bApplicationByIdRemoveInviteByInviteIdErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdRemoveInviteByInviteIdResponses, PostApiB2bApplicationByIdRemoveInviteByInviteIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/remove_invite/{inviteId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend an invite
 */
export const postApiB2bApplicationByIdResendInviteByInviteId = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdResendInviteByInviteIdData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdResendInviteByInviteIdResponses, PostApiB2bApplicationByIdResendInviteByInviteIdErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdResendInviteByInviteIdResponses, PostApiB2bApplicationByIdResendInviteByInviteIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/resend_invite/{inviteId}',
    ...options
});

/**
 * Transition application state
 */
export const postApiB2bApplicationByIdTransition = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdTransitionData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdTransitionResponses, PostApiB2bApplicationByIdTransitionErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdTransitionResponses, PostApiB2bApplicationByIdTransitionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/transition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get application details
 */
export const getApiB2bApplicationByIdGet = <ThrowOnError extends boolean = false>(options: Options<GetApiB2bApplicationByIdGetData, ThrowOnError>): RequestResult<GetApiB2bApplicationByIdGetResponses, GetApiB2bApplicationByIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetApiB2bApplicationByIdGetResponses, GetApiB2bApplicationByIdGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/get',
    ...options
});

/**
 * Edit application details
 */
export const postApiB2bApplicationByIdEdit = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdEditData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdEditResponses, PostApiB2bApplicationByIdEditErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdEditResponses, PostApiB2bApplicationByIdEditErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Debug transition
 */
export const postApiB2bApplicationByIdDebugTransition = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdDebugTransitionData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdDebugTransitionResponses, PostApiB2bApplicationByIdDebugTransitionErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdDebugTransitionResponses, PostApiB2bApplicationByIdDebugTransitionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/debug-transition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Collect initiative data
 */
export const postApiB2bApplicationByIdCollectInitiativeData = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdCollectInitiativeDataData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdCollectInitiativeDataResponses, PostApiB2bApplicationByIdCollectInitiativeDataErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdCollectInitiativeDataResponses, PostApiB2bApplicationByIdCollectInitiativeDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/collect_initiative_data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Estimate initiative reduction
 */
export const postApiB2bApplicationByIdInitiativeEstimateReduce = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdInitiativeEstimateReduceData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdInitiativeEstimateReduceResponses, PostApiB2bApplicationByIdInitiativeEstimateReduceErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdInitiativeEstimateReduceResponses, PostApiB2bApplicationByIdInitiativeEstimateReduceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/initiative-estimate-reduce',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable annual update for an application
 *
 * Creates a new follow-on application within the same package with the next consecutive reporting period. Inherits settings and role assignments from the previous application.
 */
export const postApiB2bApplicationByIdEnableAnnualUpdate = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdEnableAnnualUpdateData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdEnableAnnualUpdateResponses, PostApiB2bApplicationByIdEnableAnnualUpdateErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdEnableAnnualUpdateResponses, PostApiB2bApplicationByIdEnableAnnualUpdateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/enable-annual-update',
    ...options
});

/**
 * Mark annual update carbon review as complete
 *
 * Called by the owner from the Annual Updates page. Finds the follow-on application (in pending_annual_update state) within the same package and transitions it to draft, making it available to the owner for the new reporting period.
 */
export const postApiB2bApplicationByIdMarkAnnualUpdateComplete = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdMarkAnnualUpdateCompleteData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdMarkAnnualUpdateCompleteResponses, PostApiB2bApplicationByIdMarkAnnualUpdateCompleteErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdMarkAnnualUpdateCompleteResponses, PostApiB2bApplicationByIdMarkAnnualUpdateCompleteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/mark-annual-update-complete',
    ...options
});

/**
 * Get copied-from snapshots for an application
 *
 * Returns previous-period snapshots for each initiative attachment on this application that was copied from a previous annual-update application.
 */
export const getApiB2bApplicationByIdCopiedFromSnapshots = <ThrowOnError extends boolean = false>(options: Options<GetApiB2bApplicationByIdCopiedFromSnapshotsData, ThrowOnError>): RequestResult<GetApiB2bApplicationByIdCopiedFromSnapshotsResponses, GetApiB2bApplicationByIdCopiedFromSnapshotsErrors, ThrowOnError> => (options.client ?? client).get<GetApiB2bApplicationByIdCopiedFromSnapshotsResponses, GetApiB2bApplicationByIdCopiedFromSnapshotsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/copied-from-snapshots',
    ...options
});

/**
 * Update initiative attachment status
 *
 * Updates the status of an initiative attachment. Statuses: todo, in_progress, complete, remove.
 */
export const postApiB2bApplicationByIdInitiativeAttachmentByAttachmentIdStatus = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bApplicationByIdInitiativeAttachmentByAttachmentIdStatusData, ThrowOnError>): RequestResult<PostApiB2bApplicationByIdInitiativeAttachmentByAttachmentIdStatusResponses, PostApiB2bApplicationByIdInitiativeAttachmentByAttachmentIdStatusErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bApplicationByIdInitiativeAttachmentByAttachmentIdStatusResponses, PostApiB2bApplicationByIdInitiativeAttachmentByAttachmentIdStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/application/{id}/initiative-attachment/{attachmentId}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get application report
 */
export const getApiB2bReportsApplicationReport = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bReportsApplicationReportData, ThrowOnError>): RequestResult<GetApiB2bReportsApplicationReportResponses, GetApiB2bReportsApplicationReportErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bReportsApplicationReportResponses, GetApiB2bReportsApplicationReportErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/api/b2b/reports/application-report',
    ...options
});

/**
 * Get finance report
 */
export const getApiB2bReportsFinanceReport = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bReportsFinanceReportData, ThrowOnError>): RequestResult<GetApiB2bReportsFinanceReportResponses, GetApiB2bReportsFinanceReportErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bReportsFinanceReportResponses, GetApiB2bReportsFinanceReportErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/api/b2b/reports/finance-report',
    ...options
});

/**
 * Get reduction initiatives report
 */
export const getApiB2bReportsReductionInitiativesReport = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bReportsReductionInitiativesReportData, ThrowOnError>): RequestResult<GetApiB2bReportsReductionInitiativesReportResponses, GetApiB2bReportsReductionInitiativesReportErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bReportsReductionInitiativesReportResponses, GetApiB2bReportsReductionInitiativesReportErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/api/b2b/reports/reduction-initiatives-report',
    ...options
});

/**
 * Execute payment
 */
export const postApiB2bPaymentExecuteById = <ThrowOnError extends boolean = false>(options: Options<PostApiB2bPaymentExecuteByIdData, ThrowOnError>): RequestResult<PostApiB2bPaymentExecuteByIdResponses, PostApiB2bPaymentExecuteByIdErrors, ThrowOnError> => (options.client ?? client).post<PostApiB2bPaymentExecuteByIdResponses, PostApiB2bPaymentExecuteByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/payment/execute/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm payment
 */
export const getApiB2bPaymentConfirm = <ThrowOnError extends boolean = false>(options?: Options<GetApiB2bPaymentConfirmData, ThrowOnError>): RequestResult<GetApiB2bPaymentConfirmResponses, GetApiB2bPaymentConfirmErrors, ThrowOnError> => (options?.client ?? client).get<GetApiB2bPaymentConfirmResponses, GetApiB2bPaymentConfirmErrors, ThrowOnError>({ url: '/api/b2b/payment/confirm', ...options });

/**
 * Payment webhook
 */
export const postApiB2bPaymentWebhook = <ThrowOnError extends boolean = false>(options?: Options<PostApiB2bPaymentWebhookData, ThrowOnError>): RequestResult<PostApiB2bPaymentWebhookResponses, PostApiB2bPaymentWebhookErrors, ThrowOnError> => (options?.client ?? client).post<PostApiB2bPaymentWebhookResponses, PostApiB2bPaymentWebhookErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/b2b/payment/webhook',
    ...options
});

/**
 * Get airport data
 */
export const getApiAirport = <ThrowOnError extends boolean = false>(options?: Options<GetApiAirportData, ThrowOnError>): RequestResult<GetApiAirportResponses, GetApiAirportErrors, ThrowOnError> => (options?.client ?? client).get<GetApiAirportResponses, GetApiAirportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/airport',
    ...options
});

/**
 * Get country data
 */
export const getApiCountry = <ThrowOnError extends boolean = false>(options?: Options<GetApiCountryData, ThrowOnError>): RequestResult<GetApiCountryResponses, GetApiCountryErrors, ThrowOnError> => (options?.client ?? client).get<GetApiCountryResponses, GetApiCountryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/country',
    ...options
});

/**
 * Get specific country data
 */
export const getApiCountryByCountryCode = <ThrowOnError extends boolean = false>(options: Options<GetApiCountryByCountryCodeData, ThrowOnError>): RequestResult<GetApiCountryByCountryCodeResponses, GetApiCountryByCountryCodeErrors, ThrowOnError> => (options.client ?? client).get<GetApiCountryByCountryCodeResponses, GetApiCountryByCountryCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/country/{country_code}',
    ...options
});

/**
 * Create/Update web session
 */
export const postApiWebSession = <ThrowOnError extends boolean = false>(options?: Options<PostApiWebSessionData, ThrowOnError>): RequestResult<PostApiWebSessionResponses, PostApiWebSessionErrors, ThrowOnError> => (options?.client ?? client).post<PostApiWebSessionResponses, PostApiWebSessionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/web_session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Fake login for testing
 */
export const postApiFakeLogin = <ThrowOnError extends boolean = false>(options?: Options<PostApiFakeLoginData, ThrowOnError>): RequestResult<PostApiFakeLoginResponses, PostApiFakeLoginErrors, ThrowOnError> => (options?.client ?? client).post<PostApiFakeLoginResponses, PostApiFakeLoginErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/fake-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Fake login by email for testing
 */
export const postApiFakeLoginEmail = <ThrowOnError extends boolean = false>(options?: Options<PostApiFakeLoginEmailData, ThrowOnError>): RequestResult<PostApiFakeLoginEmailResponses, PostApiFakeLoginEmailErrors, ThrowOnError> => (options?.client ?? client).post<PostApiFakeLoginEmailResponses, PostApiFakeLoginEmailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/fake-login/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Ping
 */
export const getApiPing = <ThrowOnError extends boolean = false>(options?: Options<GetApiPingData, ThrowOnError>): RequestResult<GetApiPingResponses, GetApiPingErrors, ThrowOnError> => (options?.client ?? client).get<GetApiPingResponses, GetApiPingErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/ping',
    ...options
});

/**
 * Get business status PDF
 */
export const getPdfBusinessStatusDocumentById = <ThrowOnError extends boolean = false>(options: Options<GetPdfBusinessStatusDocumentByIdData, ThrowOnError>): RequestResult<GetPdfBusinessStatusDocumentByIdResponses, GetPdfBusinessStatusDocumentByIdErrors, ThrowOnError> => (options.client ?? client).get<GetPdfBusinessStatusDocumentByIdResponses, GetPdfBusinessStatusDocumentByIdErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/pdf/business_status_document/{id}',
    ...options
});

/**
 * Generate reduction document PDF
 */
export const postPdfBusinessReductionDocumentById = <ThrowOnError extends boolean = false>(options: Options<PostPdfBusinessReductionDocumentByIdData, ThrowOnError>): RequestResult<PostPdfBusinessReductionDocumentByIdResponses, PostPdfBusinessReductionDocumentByIdErrors, ThrowOnError> => (options.client ?? client).post<PostPdfBusinessReductionDocumentByIdResponses, PostPdfBusinessReductionDocumentByIdErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/pdf/business_reduction_document/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate carbon emissions PDF
 */
export const postPdfBusinessCarbonEmissionsById = <ThrowOnError extends boolean = false>(options: Options<PostPdfBusinessCarbonEmissionsByIdData, ThrowOnError>): RequestResult<PostPdfBusinessCarbonEmissionsByIdResponses, PostPdfBusinessCarbonEmissionsByIdErrors, ThrowOnError> => (options.client ?? client).post<PostPdfBusinessCarbonEmissionsByIdResponses, PostPdfBusinessCarbonEmissionsByIdErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/pdf/business_carbon_emissions/{id}',
    ...options
});

/**
 * Get invoice PDF
 */
export const getPdfBusinessInvoiceById = <ThrowOnError extends boolean = false>(options: Options<GetPdfBusinessInvoiceByIdData, ThrowOnError>): RequestResult<GetPdfBusinessInvoiceByIdResponses, GetPdfBusinessInvoiceByIdErrors, ThrowOnError> => (options.client ?? client).get<GetPdfBusinessInvoiceByIdResponses, GetPdfBusinessInvoiceByIdErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/pdf/business_invoice/{id}',
    ...options
});

/**
 * Generate reduction plan PDF
 */
export const postPdfBusinessReductionPlanById = <ThrowOnError extends boolean = false>(options: Options<PostPdfBusinessReductionPlanByIdData, ThrowOnError>): RequestResult<PostPdfBusinessReductionPlanByIdResponses, PostPdfBusinessReductionPlanByIdErrors, ThrowOnError> => (options.client ?? client).post<PostPdfBusinessReductionPlanByIdResponses, PostPdfBusinessReductionPlanByIdErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/pdf/business_reduction_plan/{id}',
    ...options
});

/**
 * Start B2B authorization
 */
export const postOauth2AuthorizationB2B = <ThrowOnError extends boolean = false>(options: Options<PostOauth2AuthorizationB2bData, ThrowOnError>): RequestResult<PostOauth2AuthorizationB2bResponses, PostOauth2AuthorizationB2bErrors, ThrowOnError> => (options.client ?? client).post<PostOauth2AuthorizationB2bResponses, PostOauth2AuthorizationB2bErrors, ThrowOnError>({
    responseType: 'json',
    url: '/oauth2/authorization-b2b',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * B2B authorization callback
 */
export const getOauth2CallbackB2B = <ThrowOnError extends boolean = false>(options?: Options<GetOauth2CallbackB2bData, ThrowOnError>): RequestResult<GetOauth2CallbackB2bResponses, GetOauth2CallbackB2bErrors, ThrowOnError> => (options?.client ?? client).get<GetOauth2CallbackB2bResponses, GetOauth2CallbackB2bErrors, ThrowOnError>({ url: '/oauth2/callback-b2b', ...options });

/**
 * B2B logout
 */
export const postOauth2LogoutB2B = <ThrowOnError extends boolean = false>(options?: Options<PostOauth2LogoutB2bData, ThrowOnError>): RequestResult<PostOauth2LogoutB2bResponses, PostOauth2LogoutB2bErrors, ThrowOnError> => (options?.client ?? client).post<PostOauth2LogoutB2bResponses, PostOauth2LogoutB2bErrors, ThrowOnError>({
    responseType: 'json',
    url: '/oauth2/logout-b2b',
    ...options
});
